import AppComponent from './AppView.jsx';

export default AppComponent;
